<script>
import { IconChevronDown } from "@/components/icons/index";
import { BButton } from "bootstrap-vue";

/**
 * TODO: CATCH INVALID UPLOADS AND DISPLAY ERROR MESSAGE
 * 1. More than one
 * 2. Corrupted or config
 * 3. Non-image
 * 4. More than specified size (3mb)
 * 5. Invalid format
 */
export default {
    components: {
        IconChevronDown,
        BButton,
    },

    props: {
        image: { type: [String, File], default: "" },
        disabled: { type: Boolean, default: false },
        hint: { type: String, default: "" },
        /** Optional { name, size } caption shown under an uploaded image (e.g. when `image` is a preview URL rather than a File) */
        meta: { type: Object, default: null },
    },

    data() {
        return {
            imageFile: "",
            imageName: "",
        };
    },

    watch: {
        image(val) {
            this.imageFile = val;
        },
    },

    computed: {
        /** True once there's either real image data or just server-provided { name, size } metadata to show */
        hasUploaded() {
            return !!this.imageFile || !!this.meta?.name;
        },
        captionText() {
            if (this.imageName) return this.imageName;
            if (this.meta?.name) {
                return this.meta.size
                    ? `${this.meta.name} • ${this.formatBytes(this.meta.size)}`
                    : this.meta.name;
            }
            return "";
        },
    },

    methods: {
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return "0 Bytes";
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files[0].type.includes("image")) return;
            this.createImage(files[0]);
            this.imageName = `${files[0].name} • ${this.formatBytes(files[0].size)}`;
        },
        createImage(file) {
            var reader = new FileReader();
            reader.onloadend = (e) => {
                this.removeImage();
                this.imageFile = e.target.result;
            };
            reader.readAsDataURL(file);
            this.$emit("upload", file);
        },
        removeImage(event, emit = false) {
            this.imageFile = "";
            this.imageName = "";
            if (emit) this.$emit("upload", null);
        },
    },
};
</script>

<template>
    <div>
        <div
            class="upload-box"
            @drop.prevent="onFileChange"
            @dragenter.prevent
            @dragover.prevent
            @click="$refs.input.click()"
            :class="{
                'pe-none opacity-75': disabled,
            }"
        >
            <input
                ref="input"
                type="file"
                accept="image/*"
                class="d-none"
                @change="onFileChange"
            />
            <div v-if="hasUploaded" class="me-auto">
                <div
                    class="image-container overflow-hidden position-relative"
                    :class="{ 'd-flex align-items-center justify-content-center bg-light': !imageFile }"
                    :style="{
                        width: '97px',
                        height: '97px',
                        borderRadius: '10px',
                    }"
                >
                    <div class="image-overlay"></div>
                    <img
                        v-if="imageFile"
                        :src="imageFile"
                        alt=""
                        style="width: 100%; height: 100%; object-fit: cover"
                    />
                    <img
                        v-else
                        src="/assets/images/icons/upload.png"
                        alt="uploaded file"
                        width="36px"
                        height="36px"
                    />
                    <div
                        class="position-absolute start-0 top-0 h-100 w-100 d-flex justify-content-center align-items-center"
                    >
                        <b-button
                            variant="primary"
                            class="button-remove"
                            size="sm"
                            @click.stop="removeImage($event, true)"
                        >
                            Delete
                        </b-button>
                    </div>
                </div>
                <p v-if="captionText" class="mt-2 mb-0 font-size-12" :style="{ color: '#74788D' }">
                    {{ captionText }}
                </p>
            </div>
            <div v-else class="text-center">
                <!-- <IconChevronDown />
        -->
                <img
                    src="/assets/images/icons/upload.png"
                    alt="upload icon"
                    width="68px"
                    height="68px"
                />
                <p
                    class="mt-3 mb-0 font-size-14 fw-medium"
                    :style="{ color: '#74788D' }"
                >
                    Drop file here or click to upload.
                </p>
                <p v-if="hint" class="mt-1 mb-0 font-size-12" :style="{ color: '#74788D' }">
                    {{ hint }}
                </p>
            </div>
        </div>

        <!-- <div class="invalid-feedback d-block mt-2">
      You can only upload files in image format.
    </div> -->
    </div>
</template>

<style lang="scss" scoped>
.upload-box {
    min-height: 160px;
    width: 100%;
    padding: 30px;
    border: 2px dashed #ced4da;
    background: #ffffff;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    .image {
        &-container {
            .button-remove {
                display: none;
            }
            &:hover {
                .image-overlay {
                    display: block;
                    background: rgba(0, 0, 0, 0.3);
                }
                .button-remove {
                    display: block;
                }
            }
        }
        &-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0);
            transition: background 0.5s ease;
        }
    }
}
</style>
